import { endsWith } from '../../utils/lang';
export function endsWithMatcherContext(ruleAttr) {
    return function endsWithMatcher(runtimeAttr) {
        var strEndsWith = ruleAttr.some(function (e) { return endsWith(runtimeAttr, e); });
        return strEndsWith;
    };
}
